import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardVendorsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

export const useAffiliateDashboardVendors = (shouldFetch: boolean) => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardVendorsInterface[]>({
    method: RequestMethodsEnum.get,
  })
  const { user } = useUser()

  return useControlledSwr(() => {
    if (!user || !shouldFetch) return
    return [`${AFFILIATE_DASHBOARD_API}/stats-by-vendors`, RequestModuleEnum.Contacts]
  }, fetcher)
}
